export const InfoIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M12,24A12,12,0,0,1,3.515,3.515,12,12,0,1,1,20.485,20.485,11.922,11.922,0,0,1,12,24ZM10.38,8.98V19.74H13.5V8.98ZM11.94,4a1.989,1.989,0,0,0-1.4.5,1.694,1.694,0,0,0,0,2.48,1.989,1.989,0,0,0,1.4.5,1.988,1.988,0,0,0,1.4-.5,1.741,1.741,0,0,0,.54-1.3,1.544,1.544,0,0,0-.54-1.2A2.035,2.035,0,0,0,11.94,4Z" fill="#535353"/>
    </svg>
  );
}
export const CauldronIcon = () => {
  return (
    <svg id="Group_1" data-name="Group 1" xmlns="http://www.w3.org/2000/svg" width="22.654" height="18" viewBox="0 0 22.654 18">
      <path id="Path_1" data-name="Path 1" d="M11.327,17.217c6.256,0,11.327-4.474,11.327-9.993A9.448,9.448,0,0,0,19.153,0H3.5A9.448,9.448,0,0,0,0,7.224C0,12.743,5.071,17.217,11.327,17.217Z" fill="#f6bd49"/>
      <rect id="Rectangle_1" data-name="Rectangle 1" width="20.842" height="1.812" rx="0.906" transform="translate(0.906)" fill="#f6bd49"/>
      <rect id="Rectangle_2" data-name="Rectangle 2" width="4.531" height="1.812" rx="0.906" transform="translate(3.625 18) rotate(-90)" fill="#f6bd49"/>
      <rect id="Rectangle_3" data-name="Rectangle 3" width="4.531" height="1.812" rx="0.906" transform="translate(17.217 18) rotate(-90)" fill="#f6bd49"/>
    </svg>

  );
}
export const CloseIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 1L1 11M1 1L11 11" stroke="#495160" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
}
export const CloseCircleIcon = () => {
  return (
    <svg width="30pt" height="30pt" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="12" fill="white"/>
      <path fill="#F6BD49" d="M 15 0 C 6.714844 0 0 6.714844 0 15 C 0 23.285156 6.714844 30 15 30 C 23.285156 30 30 23.285156 30 15 C 30 6.714844 23.285156 0 15 0 Z M 19.167969 21.441406 L 15 17.273438 L 10.832031 21.441406 L 8.558594 19.167969 L 12.726562 15 L 8.558594 10.832031 L 10.832031 8.558594 L 15 12.726562 L 19.167969 8.558594 L 21.441406 10.832031 L 17.273438 15 L 21.441406 19.167969 Z M 19.167969 21.441406 "/>
    </svg>
  );
}

export const CheckMark = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#005789" d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg>
  );
}
